import {
  IAddDepositRequest,
  IDeductDepositRequest,
  IDepositTransaction,
} from '../interfaces/Deposit';
import {
  PaginationParamsRequest,
  PaginationParamsResponse,
} from '../interfaces/PaginationParamsResponse';
import Client from './client';

class DepositApi {
  private static classInstance?: DepositApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new DepositApi();
    }
    return this.classInstance;
  }

  public addDeposit(body: IAddDepositRequest): Promise<IDepositTransaction> {
    return Client.post(`/user/deposit/add`, body);
  }

  public deductDeposit(
    body: IDeductDepositRequest
  ): Promise<IDepositTransaction> {
    return Client.post(`/user/deposit/deduct`, body);
  }

  public getDepositTransactions(
    sellerId: string,
    query: PaginationParamsRequest
  ): Promise<PaginationParamsResponse<IDepositTransaction>> {
    return Client.get(`/user/${sellerId}/deposit/transactions/`, {
      params: query,
    });
  }
}

export default DepositApi.instance;
